export default __webpack_public_path__ + "static/media/img1.d8a7517d.jpg";